import { useEffect, useState } from 'react'
import { track } from '../../utils'

export default function CustomPageTracking({ handle, payload = {} }) {
  const [didTrack, setDidTrack] = useState(false)

  useEffect(() => {
    if (!didTrack) {
      setDidTrack(true)
      track(handle, payload)
    }
  }, [payload, handle, didTrack])

  return null
}
